import { render } from "./GobMedia.vue?vue&type=template&id=21e2f1bd"
import script from "./GobMedia.vue?vue&type=script&lang=js"
export * from "./GobMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__